module.exports = __webpack_public_path__ + "static/images/challenge.b2cf654c3a96f651162c6f50331c1319.jpg";